import { Fragment } from "react";
import { ImageContainer, ImageStyled } from "./styles";

function AdviceArticleHeader(props) {
  const { blog } = props || {};
  return (
    <Fragment>
      <ImageContainer>
        <ImageStyled
          src={blog?.attributes?.coverImage?.data?.attributes?.url}
        />
      </ImageContainer>
    </Fragment>
  );
}

export default AdviceArticleHeader;
